import { render, staticRenderFns } from "./journalsMine.vue?vue&type=template&id=199d2435&scoped=true"
import script from "./journalsMine.vue?vue&type=script&lang=js"
export * from "./journalsMine.vue?vue&type=script&lang=js"
import style0 from "./journalsMine.vue?vue&type=style&index=0&id=199d2435&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199d2435",
  null
  
)

export default component.exports